<template>
  <div class="app-container">
    <!-- <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-input
              v-model="query.condition"
              @keyup.enter.native="resetList"
              placeholder="名称"
            ></el-input>
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="resetList" type="primary">确认查询</el-button>
        </div>
      </div>
    </el-form> -->

    <div class="table-wrapper">
      <el-table :data="list" v-loading="listLoading">
        <el-table-column
          align="center"
          type="index"
          width="60"
          fixed="left"
          label="#"
        ></el-table-column>
        <el-table-column align="center" label="名称">
          <template slot-scope="scope">
            {{ scope.row.name | filterName }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="表格操作" width="150" fixed="right">
          <template slot-scope="scope">
            <p>
              <el-button type="primary" @click="handleEdit(scope.row)">编辑</el-button>
            </p>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="编辑参数" :visible.sync="dialogVisible" :width="form.dialogWidth || '450px'">
      <el-form class="post-main-container post-dialog-container">
        <el-form-item label="名称：" class="form-text">
          {{ form.name | filterName }}
        </el-form-item>
        <div v-if="form.type === 'editor'" class="dialog-editor-container">
          <el-form-item label="内容：">
            <Tinymce @listenChangeEditorValue="changeEditorValue" :value="form.value"></Tinymce>
          </el-form-item>
        </div>
        <div v-if="form.type === 'Array'" class="dialog-editor-container">
          <el-form-item label="内容：">
            <div
              v-for="(item, index) in form.content"
              :key="index"
              class="flex items-center mb-15px"
            >
              <div class="flex items-center recharge_item" v-if="form.key === 'RECHARGE'">
                <div class="whitespace-nowrap mr-15px">充值金额</div>
                <el-input v-model="item.sum" placeholder=""></el-input>
                <div class="mlr-15px whitespace-nowrap">赠送金额</div>
                <el-input v-model="item.giveSum" placeholder=""></el-input>
                <div class="mlr-15px whitespace-nowrap">选择用户占比</div>
                <el-input placeholder="" v-model="item.ratio"></el-input>
                <div class="ml-5px">%</div>
              </div>
              <div class="flex items-center" v-else-if="form.key === 'CHARGE'">
                <div class="mlr-15px whitespace-nowrap">时长</div>
                <el-input v-model="item.time" placeholder="">
                  <template slot="append">小时</template>
                </el-input>
              </div>
              <div @click="handleClick(index)" class="ml-15px">
                <i class="el-icon-circle-plus" v-if="index === 0"></i>
                <i class="el-icon-remove" v-else></i>
              </div>
            </div>
          </el-form-item>
        </div>
        <div v-if="form.type === 'input'">
          <el-form-item label="内容：">
            <el-input v-model="form.content" class="mb-8px w-200px" />
          </el-form-item>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitData" :loading="btnLoading">提交</el-button>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Tinymce from '@/components/tinymce'
import { list, update } from '@/api/marketing'

export default {
  components: { Tinymce },

  data() {
    return {
      list: [],
      listTotal: 0,
      listLoading: true,

      query: {
        pageIndex: 1,
        pageSize: 100
      },

      btnLoading: false,
      dialogVisible: false,
      form: {
        id: '',
        name: '',
        type: '',
        content: '',
        dialogWidth: '',
        code: '',
        key: ''
      }
    }
  },

  filters: {
    filterName(val) {
      const map = {
        CHARGE: '充电套餐',
        RECHARGE: '充值套餐',
        MONTH_CARD_NEW_USER_DISCOUNT: '月卡新用户优惠'
      }

      return map[val] || val
    }
  },

  created() {
    this.resetList()
  },

  methods: {
    resetList() {
      this.query.pageIndex = 1
      this.getList()
    },

    getList() {
      this.listLoading = true

      list(this.query).then((res) => {
        console.log('营销管理 :>> ', res)
        res.data.records = res.data.records.filter(
          (item) => ['CHARGE', 'MONTH_CARD_NEW_USER_DISCOUNT'].indexOf(item.key) !== -1
        )

        this.list = res.data.records.map((item) => {
          if (['CHARGE'].indexOf(item.key) !== -1) {
            item.type = 'Array'
            item.dialogWidth = '800px'
            item.content = JSON.parse(item.content)
          } else if (['MONTH_CARD_NEW_USER_DISCOUNT'].indexOf(item.key) !== -1) {
            item.type = 'input'
            item.dialogWidth = '400px'
          }
          return item
        })

        this.listTotal = parseInt(res.data.pager.itemCount)
        this.listLoading = false
      })
    },

    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    },

    handleEdit(row) {
      this.dialogVisible = true

      this.$resetForm(this.form, row)
    },

    changeEditorValue(val) {
      this.form.value = val
    },

    generateUUID() {
      // eslint-disable-next-line no-var
      var d = new Date().getTime()
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now() // use high-precision timer if available
      }
      // eslint-disable-next-line no-var, vars-on-top
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-var, no-bitwise
        var r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        // eslint-disable-next-line eqeqeq, no-bitwise
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
      return uuid
    },

    handleClick(index) {
      if (index !== 0) {
        this.form.content.splice(index, 1)
        return
      }
      const params = {
        code: this.generateUUID(),
      }
      this.form.content.push(params)
    },

    submitData() {
      this.btnLoading = true
      const form = JSON.parse(JSON.stringify(this.form))
      if (form.type === 'Array') form.content = JSON.stringify(form.content)

      update(form).then(() => {
        this.btnLoading = false
        this.dialogVisible = false

        this.$message.success('提交数据成功')
        this.getList()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-editor-container {
  height: 400px;
}
.whitespace-nowrap {
  white-space: nowrap;
}
</style>
<style lang="scss">
.recharge_item {
  .el-input__inner {
    width: 100px !important;
  }
}
</style>
